import React, { useEffect, useState } from "react";
import { Formik, Form, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../CustomComponents/FieldInput";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { fireStore } from "../../../../Firebase/config";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import { urlValidation } from "../../../../CloudStorage/CommonFunction";
import { titlevalidation } from "../../../Common/commonvalidation";
import { useFileValidator } from "../../../../hooks/useFileValidator";
import UploadLoader from "../../../Common/Loader/UploadLoader";

const bxpDatatomap = [
  { title: "Project title", name: "title", placeholder: "Enter title" },
  {
    title: "Upload file* (Upload at least 1 file) ",
    name: "files",
    placeholder: "Drag and drop or Browse file",
  },
  { title: "Project URL", name: "url", placeholder: "Project URL" },
];

const validationSchema = Yup.object().shape({
  work_samples: Yup.array()
    .of(
      Yup.object().shape({
        title: titlevalidation,
        url: Yup.string()
          .test("valid-url", "Enter a valid URL", (value) =>
            urlValidation(value),
          )
          .required("URL is required"),
        files: Yup.array()
          .of(
            Yup.object().shape({
              file: Yup.mixed().required("File is required"),
            }),
          )
          .required("Files are required")
          .min(1, "At least one file is required"),
      }),
    )
    .required("Must have work samples")
    .min(1, "Minimum of 1 work sample"),
});

const WorkSamples = ({ bxpData, setbxpData, setActiveTab }) => {
  const { validating, validateFiles } = useFileValidator();
  const [isUploading, setIsUploading] = useState(false); // 🛡️ Added upload state

  const initialValues = {
    work_samples: bxpData?.work_samples || [
      {
        title: "",
        url: "",
        files: [{ file: "", preview: "" }],
      },
    ],
  };

  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const uploadFileToFirebase = (file) => {
    return new Promise((resolve, reject) => {
      // Fixed template literal spacing for accurate storage path
      const storageRef = ref(
        getStorage(fireStore),
        `work_samples/${file.name}`, 
      );
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {},
        (error) => {
          reject(error);
        },
        async () => {
          const url = await getDownloadURL(uploadTask.snapshot.ref);
          resolve(url);
        },
      );
    });
  };

  const handleSubmit = async (values, actions) => {
    setIsUploading(true); // 🟢 Start loader when form submission begins
    try {
      const workSamples = await Promise.all(
        values.work_samples.map(async (sample) => {
          const files = await Promise.all(
            sample.files.map(async (fileObj) => {
              // Only upload if it's a File object (meaning it's new), otherwise keep existing URL
              if (fileObj.file instanceof File) {
                const url = await uploadFileToFirebase(fileObj.file);
                return { file: url };
              }
              return fileObj;
            }),
          );
          return { ...sample, files };
        }),
      );

      const updatedValues = { ...values, work_samples: workSamples };
      setbxpData((prevData) => ({
        ...prevData,
        work_samples: updatedValues.work_samples,
      }));
      
      setIsUploading(false); // 🔴 Stop loader on success
      setActiveTab("PricingTerms");
    } catch (error) {
      setIsUploading(false); // 🔴 Stop loader on error
      urtoast(error.message, 2);
    }
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => (
          <Form>
            <div>
              <h1>Add work sample</h1>
              
              {/* Show main loader overlay if uploading the form */}
              {isUploading && <UploadLoader />} 
              
              <FieldArray name="work_samples">
                {({ push, remove }) => (
                  <>
                    {formik.values.work_samples.map((sample, index) => (
                      <div key={index} className="work-sample">
                        {bxpDatatomap.map((prop, key) => {
                          if (prop.name == "files") {
                            return (
                              <div key={key} className="form-group position-relative">
                                {/* Show loader if files are actively validating */}
                                {validating && <UploadLoader />}
                                
                                <h6 className="skill-right file-attachment">
                                  {prop.title} <sup>*</sup>
                                  <span>{prop.placeholder}</span>
                                </h6>
                                {}
                                {formik.values.work_samples[index].files[0]
                                  .preview ? (
                                  <div className="col-md-5 p-0">
                                    <div className="image-container">
                                      <img
                                        src={
                                          formik.values.work_samples[index]
                                            .files[0].preview
                                        }
                                        className="cover-img w-100"
                                        alt="Uploaded"
                                      />
                                      <button
                                        type="button"
                                        disabled={isUploading} // Prevent delete while uploading
                                        onClick={() =>
                                          formik.setFieldValue(
                                            `work_samples[${index}].files[0]`,
                                            { file: "", preview: "" },
                                          )
                                        }
                                      >
                                        <img
                                          src={`${CloudStorage.cloudurl}/Assets//Images/contestdetails/100/delete-icon.svg`}
                                          alt="Delete"
                                        />
                                      </button>
                                    </div>
                                  </div>
                                ) : formik.values.work_samples[index].files[0]
                                  .file ? (
                                  <div className="col-md-5 p-0">
                                    <div className="image-container">
                                      <img
                                        src={
                                          formik.values.work_samples[index]
                                            .files[0].file
                                        }
                                        className="cover-img w-100"
                                        alt="Uploaded"
                                      />
                                      <button
                                        type="button"
                                        disabled={isUploading}
                                        onClick={() =>
                                          formik.setFieldValue(
                                            `work_samples[${index}].files[0]`,
                                            { file: "", preview: "" },
                                          )
                                        }
                                      >
                                        <img
                                          src={`${CloudStorage.cloudurl}/Assets//Images/contestdetails/100/delete-icon.svg`}
                                          alt="Delete"
                                        />
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="col-md-5 p-0">
                                    <div className="image-container">
                                      <img
                                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/file-upload.png`}
                                        className="cover-img w-100"
                                        alt="Placeholder"
                                      />
                                    </div>
                                  </div>
                                )}
                                <ErrorMessage
                                  name={`work_samples[${index}].files[0].file`}
                                  component="div"
                                  className="error"
                                />
                                <div 
                                  className="borderstylex"
                                  style={{ cursor: (validating || isUploading) ? "not-allowed" : "pointer" }}
                                >
                                  <input
                                    onChange={async ({ target }) => {
                                      const files = Array.from(target.files);
                                      const isValid = await validateFiles(files);
                                      if (!isValid) {
                                        target.value = "";
                                        return;
                                      }
                                      const file = target.files[0];
                                      const fileReader = new FileReader();
                                      fileReader.onload = () => {
                                        formik.setFieldValue(
                                          `work_samples[${index}].files[0].file`,
                                          file,
                                        );
                                        formik.setFieldValue(
                                          `work_samples[${index}].files[0].preview`,
                                          fileReader.result,
                                        );
                                      };
                                      fileReader.readAsDataURL(file);
                                    }}
                                    type="file"
                                    placeholder="Select Image"
                                    style={{ display: "none" }}
                                    id={`image-${index}`}
                                    name={`image-${index}`}
                                    disabled={validating || isUploading}
                                  />
                                  <label 
                                    htmlFor={`image-${index}`}
                                    style={{ cursor: (validating || isUploading) ? "not-allowed" : "pointer" }}
                                  >
                                    Drag and drop or <span>Browse file</span>
                                  </label>
                                </div>

                                <ul className="border-ul">
                                  <li>
                                    Images (JPG, PNG, JPEG up to 10MB, No more
                                    than 2000px)
                                  </li>
                                  <li>Documents (PDF, DOCX, XLSX, PPTX, ZIP upto 10MB)</li>
                                </ul>
                              </div>
                            );
                          }
                          return (
                            <FieldInput
                              key={key}
                              title={prop.title}
                              name={`work_samples[${index}].${prop.name}`}
                              placeholder={prop.placeholder}
                              disabled={isUploading}
                            />
                          );
                        })}
                        {formik.values.work_samples.length > 1 && (
                          <button 
                            type="button" 
                            onClick={() => remove(index)}
                            disabled={isUploading}
                          >
                            Remove Sample
                          </button>
                        )}
                      </div>
                    ))}
                    <button
                      type="button"
                      disabled={isUploading}
                      onClick={() =>
                        push({
                          title: "",
                          url: "",
                          files: [{ file: "", preview: "" }],
                        })
                      }
                    >
                      Add More Sample
                    </button>
                  </>
                )}
              </FieldArray>
              <div className="button-container">
                <div
                  type="button"
                  className="prev-button btn w-100"
                  style={{ pointerEvents: isUploading ? 'none' : 'auto', opacity: isUploading ? 0.6 : 1 }}
                  onClick={() => !isUploading && setActiveTab("BXPDetails")}
                >
                  Back
                </div>
                <div
                  className="next-button btn w-100"
                  type="submit"
                  style={{ pointerEvents: isUploading ? 'none' : 'auto', opacity: isUploading ? 0.6 : 1 }}
                  onClick={() => !isUploading && formik.handleSubmit()}
                >
                  {isUploading ? "Uploading..." : "Next"}
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default WorkSamples;